function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Api from "../ajax/OrganizationApi";
import moment from 'moment';
import IntlMessage from '../commons/Intl';
import { Errors, Organization, Placeholder, Action, Label, Options, Services, Protocols, EnableOptions, UsageOptions } from '../commons/IntlMessages';
import { NullNumberToBlank } from "../commons/Utility";
import { ServiceTypes } from "../enum/ServiceTypes";
import { ServiceStatuses } from "../enum/ServiceStatuses";
import { LicenseTypes } from "../enum/LicenseTypes";
import { ServerTypes } from "../enum/ServerTypes";
import { ProtocolTypes } from "../enum/ProtocolTypes";
import ReactDatePicker from "react-datepicker";
import CustomNotRequiredDateComponent from "./CustomNotRequiredDateComponent";
import * as Utility from "../commons/Utility";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // ページモーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 追加
   */

  Mode[Mode["Add"] = 1] = "Add";
  /**
   * 更新
   */

  Mode[Mode["Modify"] = 2] = "Modify";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Add:
        _this.state = {
          Modal: null,
          OrganizationId: "",
          OrganizationName: "",
          Domain: "",
          UseEverywhere: false,
          UseOneDrive: false,
          ClientId: "",
          UserMaxCount: "",
          GuestMaxCount: "",
          ServiceType: "",
          ProtocolType: "",
          ExtentionFlg: "0",
          PhotonSettingId: "",
          UseLiveOption: "0",
          UseRemoteSupportOption: "0",
          UseStreamingOption: "0",
          UsePcVrOption: "0",
          UseChatBotOption: "0",
          UseTranslationOption: "0",
          UseEffectOption: "0",
          UseLargeCapacityOption: "0",
          UseDataIntegrationOption: "0",
          Use3dgsOption: "0",
          UseMapOption: "0",
          UseFullbodyAvatarOption: "0",
          Deleted: "0",
          DisplayContractId: null,
          UpdateFlag: false,
          ContractAddFlag: false,
          ContractUpdateFlag: false,
          DeleteContractIdList: [],
          ContractList: [],
          PhotonSettingName: "Unknown",
          PhotonSettingInfo: "Unknown",
          TrialStartDate: null,
          PaidStartDate: null,
          ContractEndDate: null,
          PhotonSettings: [],
          ErrorMessages: []
        };
        break;

      case Mode.Modify:
        if (_this.props.contractList.length > 0) {
          var contractList = [];

          _this.props.contractList.map(function (x) {
            contractList.push({
              ContractId: x.ContractId,
              UserMaxCount: String(x.UserMaxCount),
              GuestMaxCount: String(x.GuestMaxCount),
              ServiceType: String(x.ServiceType),
              ProtocolType: String(x.ProtocolType),
              ExtentionFlg: String(x.ExtentionFlg),
              PhotonSettingId: String(x.PhotonSettingId),
              UseLiveOption: String(x.UseLiveOption),
              UseRemoteSupportOption: String(x.UseRemoteSupportOption),
              UseStreamingOption: String(x.UseStreamingOption),
              UsePcVrOption: String(x.UsePcVrOption),
              UseChatBotOption: String(x.UseChatBotOption),
              UseTranslationOption: String(x.UseTranslationOption),
              UseEffectOption: String(x.UseEffectOption),
              UseLargeCapacityOption: String(x.UseLargeCapacityOption),
              UseDataIntegrationOption: String(x.UseDataIntegrationOption),
              Use3dgsOption: String(x.Use3dgsOption),
              UseMapOption: String(x.UseMapOption),
              UseFullbodyAvatarOption: String(x.UseFullbodyAvatarOption),
              TrialStartDate: Utility.ToMoment2(x.TrialStartDate),
              PaidStartDate: Utility.ToMoment2(x.PaidStartDate),
              ContractEndDate: Utility.ToMoment2(x.ContractEndDate),
              ContractUpdateFlag: false
            });
          });

          _this.state = {
            Modal: null,
            OrganizationId: _this.props.organizationId,
            OrganizationName: _this.props.organizationName,
            Domain: _this.props.domain,
            UseEverywhere: _this.props.useEverywhere,
            UseOneDrive: _this.props.useOneDrive,
            ClientId: _this.props.clientId,
            UserMaxCount: String(_this.props.contractList[0].UserMaxCount),
            GuestMaxCount: String(_this.props.contractList[0].GuestMaxCount),
            ServiceType: String(_this.props.contractList[0].ServiceType),
            ProtocolType: String(_this.props.contractList[0].ProtocolType),
            ExtentionFlg: String(_this.props.contractList[0].ExtentionFlg),
            PhotonSettingId: String(_this.props.contractList[0].PhotonSettingId),
            UseLiveOption: String(_this.props.contractList[0].UseLiveOption),
            UseRemoteSupportOption: String(_this.props.contractList[0].UseRemoteSupportOption),
            UseStreamingOption: String(_this.props.contractList[0].UseStreamingOption),
            UsePcVrOption: String(_this.props.contractList[0].UsePcVrOption),
            UseChatBotOption: String(_this.props.contractList[0].UseChatBotOption),
            UseTranslationOption: String(_this.props.contractList[0].UseTranslationOption),
            UseEffectOption: String(_this.props.contractList[0].UseEffectOption),
            UseLargeCapacityOption: String(_this.props.contractList[0].UseLargeCapacityOption),
            UseDataIntegrationOption: String(_this.props.contractList[0].UseDataIntegrationOption),
            Use3dgsOption: String(_this.props.contractList[0].Use3dgsOption),
            UseMapOption: String(_this.props.contractList[0].UseMapOption),
            UseFullbodyAvatarOption: String(_this.props.contractList[0].UseFullbodyAvatarOption),
            Deleted: _this.props.deleted,
            DisplayContractId: _this.props.contractList[0].ContractId,
            UpdateFlag: false,
            ContractAddFlag: false,
            ContractUpdateFlag: false,
            DeleteContractIdList: [],
            ContractList: contractList,
            PhotonSettingName: "Unknown",
            PhotonSettingInfo: "Unknown",
            TrialStartDate: Utility.ToMoment2(_this.props.contractList[0].TrialStartDate),
            PaidStartDate: Utility.ToMoment2(_this.props.contractList[0].PaidStartDate),
            ContractEndDate: Utility.ToMoment2(_this.props.contractList[0].ContractEndDate),
            PhotonSettings: [],
            ErrorMessages: []
          };
        } else {
          _this.state = {
            Modal: null,
            OrganizationId: _this.props.organizationId,
            OrganizationName: _this.props.organizationName,
            Domain: _this.props.domain,
            UseEverywhere: _this.props.useEverywhere,
            UseOneDrive: _this.props.useOneDrive,
            ClientId: _this.props.clientId,
            UserMaxCount: "",
            GuestMaxCount: "",
            ServiceType: "",
            ProtocolType: "",
            ExtentionFlg: "0",
            PhotonSettingId: "",
            UseLiveOption: "0",
            UseRemoteSupportOption: "0",
            UseStreamingOption: "0",
            UsePcVrOption: "0",
            UseChatBotOption: "0",
            UseTranslationOption: "0",
            UseEffectOption: "0",
            UseLargeCapacityOption: "0",
            UseDataIntegrationOption: "0",
            Use3dgsOption: "0",
            UseMapOption: "0",
            UseFullbodyAvatarOption: "0",
            Deleted: _this.props.deleted,
            DisplayContractId: null,
            UpdateFlag: false,
            ContractAddFlag: false,
            ContractUpdateFlag: false,
            DeleteContractIdList: [],
            ContractList: [],
            PhotonSettingName: "Unknown",
            PhotonSettingInfo: "Unknown",
            TrialStartDate: null,
            PaidStartDate: null,
            ContractEndDate: null,
            PhotonSettings: [],
            ErrorMessages: []
          };
        }

        break;

      default:
        throw Error();
    }

    Api.GetPhotonSettings(function (model) {
      _this.setState({
        PhotonSettings: model.PhotonSettings
      }, function () {
        _this.setPhotonSetting(Number(_this.state.PhotonSettingId));
      });
    });
    return _this;
  }
  /**
   * 組織名を更新します。
   *
   * @param e イベント
   */


  _createClass(MainComponent, [{
    key: "updateOrganizationName",
    value: function updateOrganizationName(e) {
      this.setState({
        UpdateFlag: true,
        OrganizationName: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * ドメインを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateDomain",
    value: function updateDomain(e) {
      this.setState({
        UpdateFlag: true,
        Domain: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * UseEverywhere利用フラグを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUseEverywhere",
    value: function updateUseEverywhere(e) {
      this.setState({
        UpdateFlag: true,
        UseEverywhere: e.target.value == "1"
      });
    }
    /**
     * サービス種別を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateServiceType",
    value: function updateServiceType(e) {
      var serviceType = e.target.value;
      var userMaxCount = this.props.maxNumberOfUsersPerOrganization;
      var guestMaxCount = this.props.maxNumberOfGuestsPerOrganization;

      if (serviceType == ServiceTypes.Starter.toString()) {
        userMaxCount = this.props.maxNumberOfUsersPerOrganizationForStarterEdition;
        guestMaxCount = this.props.maxNumberOfGuestsPerOrganizationForStarterEdition;
      }

      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        UserMaxCount: NullNumberToBlank(userMaxCount),
        GuestMaxCount: NullNumberToBlank(guestMaxCount),
        ServiceType: serviceType
      });
    }
    /**
     * ユーザー最大登録数を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUserMaxCount",
    value: function updateUserMaxCount(e) {
      var value = e.target.value.substring(0, e.target.maxLength);
      var count = Number(value);
      if (isNaN(count) || count < 0) value = "";
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        UserMaxCount: value
      });
    }
    /**
     * ゲスト最大登録数を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateGuestMaxCount",
    value: function updateGuestMaxCount(e) {
      var value = e.target.value.substring(0, e.target.maxLength);
      var count = Number(value);
      if (isNaN(count) || count < 0) value = "";
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        GuestMaxCount: value
      });
    }
    /**
     * プロトコル種別を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateProtocolType",
    value: function updateProtocolType(e) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        ProtocolType: e.target.value
      });
    }
    /**
     * Photon設定を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updatePhotonSettingId",
    value: function updatePhotonSettingId(e) {
      var _this2 = this;

      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        PhotonSettingId: e.target.value
      }, function () {
        _this2.setPhotonSetting(Number(_this2.state.PhotonSettingId));
      });
    }
    /**
     * 拡張フラグを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateExtentionFlg",
    value: function updateExtentionFlg(e) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        ExtentionFlg: e.target.value
      });
    }
    /**
     * WHITERROOM LIVEを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUseLiveOption",
    value: function updateUseLiveOption(e) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        UseLiveOption: e.target.value
      });
    } ///**
    // * リモートサポートオプションを更新します。
    // * 
    // * @param e イベント
    // */
    //private updateUseRemoteSupportOption(e: React.ChangeEvent<HTMLSelectElement>): void {
    //    this.setState({
    //        UpdateFlag: true,
    //        ContractUpdateFlag: true,
    //        UseRemoteSupportOption: e.target.value
    //    });
    //}

    /**
     * ストリーミングオプションを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUseStreamingOption",
    value: function updateUseStreamingOption(e) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        UseStreamingOption: e.target.value
      });
    }
    /**
     * PCVRオプションを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUsePcVrOption",
    value: function updateUsePcVrOption(e) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        UsePcVrOption: e.target.value
      });
    }
    /**
     * チャットボットオプションを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUseChatBotOption",
    value: function updateUseChatBotOption(e) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        UseChatBotOption: e.target.value
      });
    }
    /**
     * 同時翻訳オプションを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUseTranslationOption",
    value: function updateUseTranslationOption(e) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        UseTranslationOption: e.target.value
      });
    }
    /**
     * エフェクトオプションを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUseEffectOption",
    value: function updateUseEffectOption(e) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        UseEffectOption: e.target.value
      });
    }
    /**
     * 大容量データオプションを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUseLargeCapacityOption",
    value: function updateUseLargeCapacityOption(e) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        UseLargeCapacityOption: e.target.value
      });
    }
    /**
     * データ連携オプションを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUseDataIntegrationOption",
    value: function updateUseDataIntegrationOption(e) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        UseDataIntegrationOption: e.target.value
      });
    }
    /**
     * 3DGSオプションを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUse3dgsOption",
    value: function updateUse3dgsOption(e) {
      // サブオプションは親が無効なら無効。保存時はサーバー側でも落とすが、
      // 画面の表示と保存内容を食い違わせないためここでも戻す。
      var enabled = e.target.value === "1";
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        Use3dgsOption: e.target.value,
        UseMapOption: enabled ? this.state.UseMapOption : "0"
      });
    }
    /**
     * 3DGSマップ機能オプションを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUseMapOption",
    value: function updateUseMapOption(e) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        UseMapOption: e.target.value
      });
    }
    /**
     * 全身アバターオプションを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUseFullbodyAvatarOption",
    value: function updateUseFullbodyAvatarOption(e) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        UseFullbodyAvatarOption: e.target.value
      });
    }
    /**
     * 「登録」ボタン押下時の処理を行います。
     */

  }, {
    key: "onEntry",
    value: function onEntry() {
      if (this.state.Modal == null) {
        throw Error();
      }

      if (!this.isValid()) {
        return;
      }

      this.props.onEntry(this.state.OrganizationName, this.state.Domain, this.state.UseEverywhere, this.state.UseOneDrive, this.state.ClientId, this.state.ContractAddFlag ? {
        UserMaxCount: Number(this.state.UserMaxCount),
        GuestMaxCount: Number(this.state.GuestMaxCount),
        ServiceType: Number(this.state.ServiceType),
        ProtocolType: Number(this.state.ProtocolType),
        ExtentionFlg: Number(this.state.ExtentionFlg),
        PhotonSettingId: Number(this.state.PhotonSettingId),
        UseLiveOption: Number(this.state.UseLiveOption),
        UseRemoteSupportOption: Number(this.state.UseRemoteSupportOption),
        UseStreamingOption: Number(this.state.UseStreamingOption),
        UsePcVrOption: Number(this.state.UsePcVrOption),
        UseChatBotOption: Number(this.state.UseChatBotOption),
        UseTranslationOption: Number(this.state.UseTranslationOption),
        UseEffectOption: Number(this.state.UseEffectOption),
        UseLargeCapacityOption: Number(this.state.UseLargeCapacityOption),
        UseDataIntegrationOption: Number(this.state.UseDataIntegrationOption),
        Use3dgsOption: Number(this.state.Use3dgsOption),
        UseMapOption: Number(this.state.UseMapOption),
        UseFullbodyAvatarOption: Number(this.state.UseFullbodyAvatarOption),
        TrialStartDate: Utility.toString(this.state.TrialStartDate),
        ContractEndDate: Utility.toString(this.state.ContractEndDate),
        PaidStartDate: Utility.toString(this.state.PaidStartDate)
      } : null);
      this.state.Modal.modal('hide');
    }
    /**
     * 「更新」ボタン押下時の処理を行います。
     */

  }, {
    key: "onModify",
    value: function onModify() {
      var _this3 = this;

      if (this.state.Modal == null) {
        throw Error();
      }

      if (!this.props.organizationId) {
        throw Error();
      }

      if (!this.isValid()) {
        return;
      }

      if (!this.state.ContractAddFlag && this.state.DisplayContractId != null) {
        this.transferToContract(this.state.ContractList.filter(function (x) {
          return x.ContractId == _this3.state.DisplayContractId;
        })[0]);
      } // 期間の重複チェック


      var periodList = [];

      if (this.state.ContractAddFlag && this.state.PaidStartDate && this.state.ContractEndDate != null) {
        var _this$state$TrialStar;

        periodList.push({
          StartDate: (_this$state$TrialStar = this.state.TrialStartDate) !== null && _this$state$TrialStar !== void 0 ? _this$state$TrialStar : this.state.PaidStartDate,
          EndDate: this.state.ContractEndDate
        });
      }

      this.state.ContractList.map(function (x) {
        if (x.PaidStartDate != null && x.ContractEndDate != null) {
          var _x$TrialStartDate;

          periodList.push({
            StartDate: (_x$TrialStartDate = x.TrialStartDate) !== null && _x$TrialStartDate !== void 0 ? _x$TrialStartDate : x.PaidStartDate,
            EndDate: x.ContractEndDate
          });
        }
      });

      if (periodList.length > 1) {
        for (var i = 0; i < periodList.length; i++) {
          for (var k = i + 1; k < periodList.length; k++) {
            if (i != k) {
              var period1 = periodList[i];
              var period2 = periodList[k];

              if (period1.StartDate.diff(period2.EndDate) <= 0 && period1.EndDate.diff(period2.StartDate) >= 0) {
                this.setState({
                  ErrorMessages: [intl.format(Errors.DuplicateContractPeriods)]
                });
                return;
              }
            }
          }
        }
      }

      var contractList = [];
      this.state.ContractList.map(function (x) {
        if (x.ContractUpdateFlag) {
          contractList.push({
            ContractId: x.ContractId,
            UserMaxCount: Number(x.UserMaxCount),
            GuestMaxCount: Number(x.GuestMaxCount),
            ServiceType: Number(x.ServiceType),
            ProtocolType: Number(x.ProtocolType),
            ExtentionFlg: Number(x.ExtentionFlg),
            PhotonSettingId: Number(x.PhotonSettingId),
            UseLiveOption: Number(x.UseLiveOption),
            UseRemoteSupportOption: Number(x.UseRemoteSupportOption),
            UseStreamingOption: Number(_this3.state.UseStreamingOption),
            UsePcVrOption: Number(_this3.state.UsePcVrOption),
            UseChatBotOption: Number(_this3.state.UseChatBotOption),
            UseTranslationOption: Number(_this3.state.UseTranslationOption),
            UseEffectOption: Number(_this3.state.UseEffectOption),
            UseLargeCapacityOption: Number(_this3.state.UseLargeCapacityOption),
            UseDataIntegrationOption: Number(_this3.state.UseDataIntegrationOption),
            Use3dgsOption: Number(_this3.state.Use3dgsOption),
            UseMapOption: Number(_this3.state.UseMapOption),
            UseFullbodyAvatarOption: Number(_this3.state.UseFullbodyAvatarOption),
            TrialStartDate: Utility.toString(x.TrialStartDate),
            ContractEndDate: Utility.toString(x.ContractEndDate),
            PaidStartDate: Utility.toString(x.PaidStartDate)
          });
        }
      });
      this.props.onModify(Number(this.props.organizationId), this.state.OrganizationName, this.state.Domain, this.state.UseEverywhere, this.state.UseOneDrive, this.state.ClientId, this.state.ContractAddFlag ? {
        UserMaxCount: Number(this.state.UserMaxCount),
        GuestMaxCount: Number(this.state.GuestMaxCount),
        ServiceType: Number(this.state.ServiceType),
        ProtocolType: Number(this.state.ProtocolType),
        ExtentionFlg: Number(this.state.ExtentionFlg),
        PhotonSettingId: Number(this.state.PhotonSettingId),
        UseLiveOption: Number(this.state.UseLiveOption),
        UseRemoteSupportOption: Number(this.state.UseRemoteSupportOption),
        UseStreamingOption: Number(this.state.UseStreamingOption),
        UsePcVrOption: Number(this.state.UsePcVrOption),
        UseChatBotOption: Number(this.state.UseChatBotOption),
        UseTranslationOption: Number(this.state.UseTranslationOption),
        UseEffectOption: Number(this.state.UseEffectOption),
        UseLargeCapacityOption: Number(this.state.UseLargeCapacityOption),
        UseDataIntegrationOption: Number(this.state.UseDataIntegrationOption),
        Use3dgsOption: Number(this.state.Use3dgsOption),
        UseMapOption: Number(this.state.UseMapOption),
        UseFullbodyAvatarOption: Number(this.state.UseFullbodyAvatarOption),
        TrialStartDate: Utility.toString(this.state.TrialStartDate),
        ContractEndDate: Utility.toString(this.state.ContractEndDate),
        PaidStartDate: Utility.toString(this.state.PaidStartDate)
      } : null, contractList, this.state.DeleteContractIdList, this.props.updateDateTime);
      this.state.Modal.modal('hide');
    }
    /**
     * 入力チェックを行います。
     */

  }, {
    key: "isValid",
    value: function isValid() {
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (!form.valid()) {
        return false;
      }

      this.state.ErrorMessages.length = 0;

      if (this.state.ContractAddFlag || this.state.ContractList.length > 0) {
        if (!(this.state.ServiceType == ServiceTypes.Enterprise.toString() || this.state.ServiceType == ServiceTypes.Starter.toString())) {
          this.state.ErrorMessages.push(intl.format(Errors.DataNotSelected, {
            title: intl.format(Label.ServiceType)
          }));
        }

        if (this.state.PhotonSettingId == "" || this.state.PhotonSettingId == "0") {
          this.state.ErrorMessages.push(intl.format(Errors.DataNotSelected, {
            title: intl.format(Label.PhotonSetting)
          }));
        }

        if (!(this.state.ProtocolType == ProtocolTypes.Tcp.toString() || this.state.ProtocolType == ProtocolTypes.Udp.toString() || this.state.ProtocolType == ProtocolTypes.Wss.toString())) {
          this.state.ErrorMessages.push(intl.format(Errors.DataNotSelected, {
            title: intl.format(Label.ProtocolType)
          }));
        }

        if (this.state.Domain != null && this.state.Domain.length > 0) {
          var domains = this.state.Domain.split(',');

          for (var i = 0; i < domains.length; i++) {
            var domain = domains[i];
            var result = domain.match(/([A-Za-z0-9\-]\.)+[A-Za-z0-9\-]+/);

            if (!result) {
              this.state.ErrorMessages.push(intl.format(Errors.InputWrongFormatWithValue, {
                title: intl.format(Label.Domain),
                value: domain
              }));
            }
          }
        }

        if (this.state.PaidStartDate != null || this.state.ContractEndDate != null) {
          if (this.state.ContractEndDate == null) {
            this.state.ErrorMessages.push(intl.format(Errors.BothInputRequired, {
              item1: intl.format(Label.PaidStartDate),
              item2: intl.format(Label.ContractEndDate)
            }));
          } else {
            if (this.state.PaidStartDate == null) {
              this.state.ErrorMessages.push(intl.format(Errors.BothInputRequired, {
                item1: intl.format(Label.ContractEndDate),
                item2: intl.format(Label.PaidStartDate)
              }));
            } else {
              if (this.state.TrialStartDate == null) {
                if (this.state.ContractEndDate.diff(this.state.PaidStartDate) < 0) {
                  this.state.ErrorMessages.push(intl.format(Errors.DateInput2ItemsPariod, {
                    item1: intl.format(Label.PaidStartDate),
                    item2: intl.format(Label.ContractEndDate)
                  }));
                }
              } else {
                if (this.state.ContractEndDate.diff(this.state.PaidStartDate) < 0 || this.state.PaidStartDate.diff(this.state.TrialStartDate) < 0) {
                  this.state.ErrorMessages.push(intl.format(Errors.DateInput3ItemsPariod, {
                    item1: intl.format(Label.TrialStartDate),
                    item2: intl.format(Label.PaidStartDate),
                    item3: intl.format(Label.ContractEndDate)
                  }));
                }
              }
            }
          }
        }
      }

      if (this.state.ErrorMessages.length != 0) {
        this.setState({
          ErrorMessages: this.state.ErrorMessages
        });
        return false;
      }

      return true;
    }
    /**
     * 「状態変更」ボタン押下時の処理を行います。
     */

  }, {
    key: "onChangeStatus",
    value: function onChangeStatus(deleted) {
      if (this.state.Modal == null || !this.props.organizationId) {
        throw Error();
      }

      var status = ServiceStatuses.Suspended.toString();
      var result = false;

      if (this.state.Deleted == ServiceStatuses.Suspended.toString()) {
        result = window.confirm(intl.format(Organization.ResumeConfirmMessage, {
          name: this.props.organizationName
        }));
      } else {
        result = window.confirm(intl.format(Organization.SuspendConfirmMessage, {
          name: this.props.organizationName
        }));
      }

      if (result) {
        if (this.state.Deleted == ServiceStatuses.Suspended.toString()) {
          status = ServiceStatuses.UnderContract.toString();
        } else {
          status = ServiceStatuses.Suspended.toString();
        }

        this.state.ErrorMessages.length = 0;
        this.props.onChangeStatus(this.props.organizationId, this.props.organizationName, status, this.props.updateDateTime);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * 契約「追加」ボタン押下時の処理を行います。
     */

  }, {
    key: "onContractAdd",
    value: function onContractAdd() {
      var _this4 = this;

      if (this.state.DisplayContractId != null) {
        this.transferToContract(this.state.ContractList.filter(function (x) {
          return x.ContractId == _this4.state.DisplayContractId;
        })[0]);
      } // 最後の契約終了日と同じ、最新がない場合は翌月の１日


      var paidStartDate = moment().startOf('month').add('month', 1);

      if (this.state.ContractList.length > 0) {
        var latest = this.state.ContractList.reduce(function (x, y) {
          return x.ContractEndDate == null ? y : y.ContractEndDate == null ? x : x.ContractEndDate.diff(y.ContractEndDate) >= 0 ? x : y;
        });

        if (latest.ContractEndDate != null) {
          paidStartDate = latest.ContractEndDate.clone().startOf('month').add('month', 1);
        }
      }

      var contractEndDate = paidStartDate.clone().startOf('day').add("second", -1).add('year', 1);
      this.setState({
        DisplayContractId: null,
        ContractAddFlag: true,
        ContractUpdateFlag: false,
        UserMaxCount: "",
        GuestMaxCount: "",
        ServiceType: "",
        ProtocolType: "",
        ExtentionFlg: "0",
        PhotonSettingId: "",
        UseLiveOption: "0",
        UseRemoteSupportOption: "0",
        UseStreamingOption: "0",
        UsePcVrOption: "0",
        UseChatBotOption: "0",
        UseTranslationOption: "0",
        UseEffectOption: "0",
        UseLargeCapacityOption: "0",
        UseDataIntegrationOption: "0",
        Use3dgsOption: "0",
        UseMapOption: "0",
        UseFullbodyAvatarOption: "0",
        PhotonSettingName: "Unknown",
        PhotonSettingInfo: "Unknown",
        TrialStartDate: null,
        PaidStartDate: paidStartDate,
        ContractEndDate: contractEndDate,
        ContractList: this.state.ContractList
      });
    }
    /**
     * 契約データを移送します。
     *
     * @param to 移送先
     */

  }, {
    key: "transferToContract",
    value: function transferToContract(to) {
      to.ContractUpdateFlag = this.state.ContractUpdateFlag;
      to.UserMaxCount = this.state.UserMaxCount;
      to.GuestMaxCount = this.state.GuestMaxCount;
      to.ServiceType = this.state.ServiceType;
      to.ProtocolType = this.state.ProtocolType;
      to.ExtentionFlg = this.state.ExtentionFlg;
      to.PhotonSettingId = this.state.PhotonSettingId;
      to.UseLiveOption = this.state.UseLiveOption;
      to.UseRemoteSupportOption = this.state.UseRemoteSupportOption;
      to.UseStreamingOption = this.state.UseStreamingOption;
      to.UsePcVrOption = this.state.UsePcVrOption;
      to.UseChatBotOption = this.state.UseChatBotOption;
      to.UseTranslationOption = this.state.UseTranslationOption;
      to.UseEffectOption = this.state.UseEffectOption;
      to.UseLargeCapacityOption = this.state.UseLargeCapacityOption;
      to.UseDataIntegrationOption = this.state.UseDataIntegrationOption;
      to.Use3dgsOption = this.state.Use3dgsOption;
      to.UseMapOption = this.state.UseMapOption;
      to.UseFullbodyAvatarOption = this.state.UseFullbodyAvatarOption;
      to.TrialStartDate = this.state.TrialStartDate;
      to.ContractEndDate = this.state.ContractEndDate;
      to.PaidStartDate = this.state.PaidStartDate;
    }
    /**
     * 契約「取消」ボタン押下時の処理を行います。
     */

  }, {
    key: "onContractCancel",
    value: function onContractCancel() {
      var _this5 = this;

      if (this.state.ContractList.length > 0) {
        var targetContract = this.state.ContractList[0];
        this.setState({
          DisplayContractId: targetContract.ContractId,
          ContractAddFlag: false,
          ContractUpdateFlag: targetContract.ContractUpdateFlag,
          UserMaxCount: targetContract.UserMaxCount,
          GuestMaxCount: targetContract.GuestMaxCount,
          ServiceType: targetContract.ServiceType,
          ProtocolType: targetContract.ProtocolType,
          ExtentionFlg: targetContract.ExtentionFlg,
          PhotonSettingId: targetContract.PhotonSettingId,
          UseLiveOption: targetContract.UseLiveOption,
          UseRemoteSupportOption: targetContract.UseRemoteSupportOption,
          UseStreamingOption: targetContract.UseStreamingOption,
          UsePcVrOption: targetContract.UsePcVrOption,
          UseChatBotOption: targetContract.UseChatBotOption,
          UseTranslationOption: targetContract.UseTranslationOption,
          TrialStartDate: targetContract.TrialStartDate,
          ContractEndDate: targetContract.ContractEndDate,
          PaidStartDate: targetContract.PaidStartDate
        }, function () {
          _this5.setPhotonSetting(Number(_this5.state.PhotonSettingId));
        });
      } else {
        this.setState({
          ContractAddFlag: false
        });
      }
    }
    /**
     * 契約「削除」ボタン押下時の処理を行います。
     */

  }, {
    key: "onContractDelete",
    value: function onContractDelete() {
      var _this6 = this;

      if (this.state.DisplayContractId == null) {
        return;
      }

      if (!window.confirm(intl.format(Organization.DeleteContractConfirmMessage))) {
        return;
      }

      var displayContractId;

      if (this.state.ContractList.length == 1) {
        displayContractId = null;
      } else {
        var index = this.state.ContractList.findIndex(function (x) {
          return x.ContractId == _this6.state.DisplayContractId;
        });

        if (index == this.state.ContractList.length - 1) {
          displayContractId = this.state.ContractList[index - 1].ContractId;
        } else {
          displayContractId = this.state.ContractList[index + 1].ContractId;
        }
      }

      this.state.DeleteContractIdList.push(this.state.DisplayContractId);
      this.setState({
        DisplayContractId: displayContractId,
        DeleteContractIdList: this.state.DeleteContractIdList,
        ContractList: this.state.ContractList.filter(function (x) {
          return x.ContractId != _this6.state.DisplayContractId;
        })
      });
    }
    /**
     * 契約ページング前へボタン押下時の処理を行います。
     */

  }, {
    key: "onContractPageingPrevious",
    value: function onContractPageingPrevious() {
      this.contractPageing(-1);
    }
    /**
     * 契約ページング次へボタン押下時の処理を行います。
     */

  }, {
    key: "onContractPageingNext",
    value: function onContractPageingNext() {
      this.contractPageing(1);
    }
    /**
     * 契約ページングボタン押下時の処理を行います。
     */

  }, {
    key: "contractPageing",
    value: function contractPageing(movement) {
      var _this7 = this;

      if (!this.isValid()) {
        return;
      }

      this.transferToContract(this.state.ContractList.filter(function (x) {
        return x.ContractId == _this7.state.DisplayContractId;
      })[0]);
      var targetContract = this.state.ContractList[this.state.ContractList.findIndex(function (x) {
        return x.ContractId == _this7.state.DisplayContractId;
      }) + movement];
      this.setState({
        DisplayContractId: targetContract.ContractId,
        ContractUpdateFlag: targetContract.ContractUpdateFlag,
        UserMaxCount: targetContract.UserMaxCount,
        GuestMaxCount: targetContract.GuestMaxCount,
        ServiceType: targetContract.ServiceType,
        ProtocolType: targetContract.ProtocolType,
        ExtentionFlg: targetContract.ExtentionFlg,
        PhotonSettingId: targetContract.PhotonSettingId,
        UseLiveOption: targetContract.UseLiveOption,
        UseRemoteSupportOption: targetContract.UseRemoteSupportOption,
        UseStreamingOption: targetContract.UseStreamingOption,
        UsePcVrOption: targetContract.UsePcVrOption,
        UseChatBotOption: targetContract.UseChatBotOption,
        UseTranslationOption: targetContract.UseTranslationOption,
        UseEffectOption: targetContract.UseEffectOption,
        UseLargeCapacityOption: targetContract.UseLargeCapacityOption,
        UseDataIntegrationOption: targetContract.UseDataIntegrationOption,
        Use3dgsOption: targetContract.Use3dgsOption,
        UseMapOption: targetContract.UseMapOption,
        UseFullbodyAvatarOption: targetContract.UseFullbodyAvatarOption,
        TrialStartDate: targetContract.TrialStartDate,
        ContractEndDate: targetContract.ContractEndDate,
        PaidStartDate: targetContract.PaidStartDate,
        ContractList: this.state.ContractList
      }, function () {
        _this7.setPhotonSetting(Number(_this7.state.PhotonSettingId));
      });
    }
    /**
     * 「削除」ボタン押下時の処理を行います。
     */

  }, {
    key: "onDelete",
    value: function onDelete() {
      if (this.state.Modal == null || !this.props.organizationId) {
        throw Error();
      }

      var result = window.confirm(intl.format(Organization.DeleteConfirmMessage, {
        name: this.props.organizationName
      }));

      if (result) {
        this.state.ErrorMessages.length = 0;
        this.props.onDelete(this.props.organizationId, this.props.organizationName, this.props.updateDateTime);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * Photon設定を反映します。
     *
     * @param photonSettingId Photon設定ID
     */

  }, {
    key: "setPhotonSetting",
    value: function setPhotonSetting(photonSettingId) {
      var settingName = "Unknown";
      var settingInfo = "Unknown";
      var settings = this.state.PhotonSettings.filter(function (p) {
        return p.Id == photonSettingId;
      });

      if (settings != null && settings.length > 0) {
        var setting = settings[0];
        settingName = setting.Name;
        var serverType = "";
        var licenseType = "";
        var fixedRegion = "";
        var ccu = "0";

        switch (setting.ServerType) {
          case ServerTypes.Cloud:
            serverType = "Cloud";
            break;

          case ServerTypes.Onpremises:
            serverType = "OnPre";
            break;
        }

        switch (setting.LicenseType) {
          case LicenseTypes.Free:
            licenseType = "Free";
            break;

          case LicenseTypes.Paid:
            licenseType = "Paid";
            break;
        }

        fixedRegion = setting.FixedRegion;
        ccu = setting.CCU.toString();
        settingInfo = serverType + ' ' + licenseType + ' ' + fixedRegion + ' ' + ccu.toString() + "CCU";
      }

      this.setState({
        PhotonSettingName: settingName,
        PhotonSettingInfo: settingInfo
      });
    }
    /**
     * トライアル開始日を更新します。
     *
     * @param d トライアル開始日
     */

  }, {
    key: "updateTrialStartDate",
    value: function updateTrialStartDate(d) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        TrialStartDate: d == null ? null : d.clone()
      });
    }
    /**
     * 有償開始日を更新します。
     *
     * @param d 有償開始日
     */

  }, {
    key: "updatePaidStartDate",
    value: function updatePaidStartDate(d) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        PaidStartDate: d == null ? null : d.clone(),
        ContractEndDate: d == null ? null : d.clone().startOf('day').add("second", -1).add('year', 1)
      });
    }
    /**
     * 契約終了日を更新します。
     *
     * @param d 契約終了日
     */

  }, {
    key: "updateContractEndDate",
    value: function updateContractEndDate(d) {
      this.setState({
        UpdateFlag: true,
        ContractUpdateFlag: true,
        ContractEndDate: d == null ? null : d.clone().startOf('day').add("day", 1).add("second", -1)
      });
    }
    /**
     * 「閉じる」ボタン押下時の処理を行います。
     */

  }, {
    key: "onClose",
    value: function onClose() {
      if (this.state.Modal == null) {
        throw Error();
      }

      if (this.state.UpdateFlag && !window.confirm(intl.format(Organization.UnregisteredConfirmMessage))) {
        return;
      }

      this.state.Modal.modal('hide');
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this8 = this;

      var modal = $('#OrganizationModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this8.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "OrganizationModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "40",
        height: "42",
        src: "/assets/img/organization_icon.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(Organization.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        onClick: this.onClose.bind(this),
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto pb-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row mb-0"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "OrganizationId"
      }, intl.format(Label.OrganizationId)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, this.props.mode == Mode.Add && /*#__PURE__*/React.createElement("label", {
        className: "col-form-label"
      }, intl.format(Label.Unregistered)), this.props.mode == Mode.Modify && /*#__PURE__*/React.createElement("label", {
        className: "col-form-label"
      }, this.props.organizationId))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "OrganizationName"
      }, intl.format(Label.OrganizationName)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "OrganizationName",
        id: "OrganizationName",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 40,
        onChange: function onChange(e) {
          return _this9.updateOrganizationName(e);
        },
        value: this.state.OrganizationName,
        tabIndex: 102,
        placeholder: intl.format(Placeholder.Letters, {
          value: "40"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "OrganizationName",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "Domain"
      }, intl.format(Label.Domain)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "Domain",
        id: "Domain",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired) + "<br />",
        maxLength: 200,
        onChange: function onChange(e) {
          return _this9.updateDomain(e);
        },
        value: this.state.Domain,
        tabIndex: 103,
        placeholder: intl.format(Placeholder.Letters, {
          value: "200"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "Domain",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }), /*#__PURE__*/React.createElement("span", null, intl.format(Organization.DomainDescription)))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UseEverywhere"
      }, intl.format(Label.UseEverywhere)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "UseEverywhere",
        name: "UseEverywhere",
        onChange: function onChange(e) {
          return _this9.updateUseEverywhere(e);
        },
        value: this.state.UseEverywhere ? "1" : "0",
        tabIndex: 104
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(UsageOptions.Suspended)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(UsageOptions.InUse)))))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto row mb-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-1"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "40",
        height: "42",
        src: "/assets/img/Icon_Contract.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-2 d-flex align-items-center"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "mb-0"
      }, intl.format(Organization.Contract))), /*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, this.state.ContractAddFlag ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary mr-1",
        onClick: this.onContractCancel.bind(this),
        tabIndex: -1
      }, intl.format(Action.Cancel)) : /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary mr-1",
        onClick: this.onContractAdd.bind(this),
        tabIndex: -1
      }, intl.format(Action.Add)), !this.state.ContractAddFlag && this.state.ContractList.length > 0 && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.onContractDelete.bind(this),
        tabIndex: -1
      }, intl.format(Action.Delete))), this.state.ContractAddFlag && /*#__PURE__*/React.createElement("div", {
        className: "col-2 pageing row align-content-center row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "disabled-img align-items-center justify-content-center row"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/arrow_left_disabled.svg"
      })), /*#__PURE__*/React.createElement("span", {
        className: "mx-2 align-items-center justify-content-center row"
      }, intl.format(Label.New)), /*#__PURE__*/React.createElement("div", {
        className: "disabled-img align-items-center justify-content-center row"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/arrow_rigth_disabled.svg"
      }))), !this.state.ContractAddFlag && this.state.ContractList.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "col-2 pageing align-items-center row"
      }, this.state.DisplayContractId == this.state.ContractList[0].ContractId ? /*#__PURE__*/React.createElement("div", {
        className: "disabled-img align-items-center justify-content-center row"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/arrow_left_disabled.svg"
      })) : /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn img-btn",
        onClick: this.onContractPageingPrevious.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/arrow_left.svg"
      })), /*#__PURE__*/React.createElement("span", {
        className: "mx-2 align-items-center justify-content-center row"
      }, this.state.DisplayContractId == this.state.ContractList[0].ContractId ? intl.format(Label.Latest) : "".concat(this.state.ContractList.findIndex(function (x) {
        return x.ContractId == _this9.state.DisplayContractId;
      }) + 1, "/").concat(this.state.ContractList.length)), this.state.DisplayContractId == this.state.ContractList[this.state.ContractList.length - 1].ContractId ? /*#__PURE__*/React.createElement("div", {
        className: "disabled-img align-items-center justify-content-center row"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/arrow_rigth_disabled.svg"
      })) : /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn img-btn",
        onClick: this.onContractPageingNext.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/arrow_rigth.svg"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto ".concat(this.state.ContractAddFlag || this.state.DisplayContractId != null ? "" : "d-none")
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "ServiceType"
      }, intl.format(Label.ServiceType)), /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "ServiceType",
        name: "ServiceType",
        onChange: function onChange(e) {
          return _this9.updateServiceType(e);
        },
        value: this.state.ServiceType,
        tabIndex: 105
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, intl.format(Options.Select)), /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(Services.Enterprise)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(Services.Starter)))), /*#__PURE__*/React.createElement("div", {
        className: "col-1"
      }), /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "Support"
      }, intl.format(Label.Support)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "Support",
        name: "Support",
        onChange: function onChange(e) {
          return _this9.updateExtentionFlg(e);
        },
        value: this.state.ExtentionFlg,
        tabIndex: 106
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(EnableOptions.Disabled)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(EnableOptions.Enabled))))), this.state.ServiceType == ServiceTypes.Starter.toString() && [/*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UserMaxCount"
      }, intl.format(Label.UserMaxCount)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        type: "number",
        className: "form-control",
        style: {
          textAlign: "right"
        },
        name: "UserMaxCount",
        id: "UserMaxCount",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 6,
        onChange: function onChange(e) {
          return _this9.updateUserMaxCount(e);
        },
        value: this.state.UserMaxCount,
        tabIndex: 107,
        placeholder: intl.format(Placeholder.Digits, {
          value: "5"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "UserMaxCount",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }), /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "GuestMaxCount"
      }, intl.format(Label.GuestMaxCount)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        type: "number",
        className: "form-control",
        style: {
          textAlign: "right"
        },
        name: "GuestMaxCount",
        id: "GuestMaxCount",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 6,
        onChange: function onChange(e) {
          return _this9.updateGuestMaxCount(e);
        },
        value: this.state.GuestMaxCount,
        tabIndex: 108,
        placeholder: intl.format(Placeholder.Digits, {
          value: "5"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "GuestMaxCount",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      })))], this.state.ServiceType == ServiceTypes.Enterprise.toString() && [/*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-7"
      }), /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "GuestMaxCount"
      }, intl.format(Label.GuestMaxCount)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        type: "number",
        className: "form-control",
        style: {
          textAlign: "right"
        },
        name: "GuestMaxCount",
        id: "GuestMaxCount",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 6,
        onChange: function onChange(e) {
          return _this9.updateGuestMaxCount(e);
        },
        value: this.state.GuestMaxCount,
        tabIndex: 109,
        placeholder: intl.format(Placeholder.Digits, {
          value: "5"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "GuestMaxCount",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      })))], /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "PhotonSettingId"
      }, intl.format(Label.PhotonSetting)), /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "PhotonSettingId",
        name: "PhotonSettingId",
        onChange: function onChange(e) {
          return _this9.updatePhotonSettingId(e);
        },
        value: this.state.PhotonSettingId,
        tabIndex: 110
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, intl.format(Options.Select)), this.state.PhotonSettings.map(function (x, i) {
        return /*#__PURE__*/React.createElement("option", {
          value: x.Id
        }, x.Name);
      })), /*#__PURE__*/React.createElement("label", {
        className: "col-form-label"
      }, this.state.PhotonSettingInfo)), /*#__PURE__*/React.createElement("div", {
        className: "col-1"
      }), /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "ProtocolType"
      }, intl.format(Label.ProtocolType)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "ProtocolType",
        name: "ProtocolType",
        onChange: function onChange(e) {
          return _this9.updateProtocolType(e);
        },
        value: this.state.ProtocolType,
        tabIndex: 111
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, intl.format(Options.Select)), /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(Protocols.Udp)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(Protocols.Tcp)), /*#__PURE__*/React.createElement("option", {
        value: "2"
      }, intl.format(Protocols.Wss))))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UseLiveOption"
      }, intl.format(Label.LiveOption)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "UseLiveOption",
        name: "UseLiveOption",
        onChange: function onChange(e) {
          return _this9.updateUseLiveOption(e);
        },
        value: this.state.UseLiveOption,
        tabIndex: 108
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(EnableOptions.Disabled)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(EnableOptions.Enabled)))), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }), /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UseStreamingOption"
      }, intl.format(Label.StreamingOption)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "UseStreamingOption",
        name: "UseStreamingOption",
        onChange: function onChange(e) {
          return _this9.updateUseStreamingOption(e);
        },
        value: this.state.UseStreamingOption,
        tabIndex: 109
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(EnableOptions.Disabled)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(EnableOptions.Enabled))))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UsePcVrOption"
      }, intl.format(Label.PcVrOption)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "UsePcVrOption",
        name: "UsePcVrOption",
        onChange: function onChange(e) {
          return _this9.updateUsePcVrOption(e);
        },
        value: this.state.UsePcVrOption,
        tabIndex: 110
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(EnableOptions.Disabled)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(EnableOptions.Enabled)))), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }), /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UseChatBotOption"
      }, intl.format(Label.ChatBotOption)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "UseChatBotOption",
        name: "UseChatBotOption",
        onChange: function onChange(e) {
          return _this9.updateUseChatBotOption(e);
        },
        value: this.state.UseChatBotOption,
        tabIndex: 111
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(EnableOptions.Disabled)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(EnableOptions.Enabled))))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UseTranslationOption"
      }, intl.format(Label.TranslationOption)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "UseTranslationOption",
        name: "UseTranslationOption",
        onChange: function onChange(e) {
          return _this9.updateUseTranslationOption(e);
        },
        value: this.state.UseTranslationOption,
        tabIndex: 112
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(EnableOptions.Disabled)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(EnableOptions.Enabled)))), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }), /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UseLargeCapacityOption"
      }, intl.format(Label.LargeCapacityOption)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "UseLargeCapacityOption",
        name: "UseLargeCapacityOption",
        onChange: function onChange(e) {
          return _this9.updateUseLargeCapacityOption(e);
        },
        value: this.state.UseLargeCapacityOption,
        tabIndex: 113
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(EnableOptions.Disabled)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(EnableOptions.Enabled))))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UseDataIntegrationOption"
      }, intl.format(Label.DataIntegrationOption)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "UseDataIntegrationOption",
        name: "UseDataIntegrationOption",
        onChange: function onChange(e) {
          return _this9.updateUseDataIntegrationOption(e);
        },
        value: this.state.UseDataIntegrationOption,
        tabIndex: 114
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(EnableOptions.Disabled)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(EnableOptions.Enabled)))), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }), /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UseEffectOption"
      }, intl.format(Label.EffectOption)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "UseEffectOption",
        name: "UseEffectOption",
        onChange: function onChange(e) {
          return _this9.updateUseEffectOption(e);
        },
        value: this.state.UseEffectOption,
        tabIndex: 115
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(EnableOptions.Disabled)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(EnableOptions.Enabled))))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "Use3dgsOption"
      }, intl.format(Label.SplatOption)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "Use3dgsOption",
        name: "Use3dgsOption",
        onChange: function onChange(e) {
          return _this9.updateUse3dgsOption(e);
        },
        value: this.state.Use3dgsOption,
        tabIndex: 116
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(EnableOptions.Disabled)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(EnableOptions.Enabled)))), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }), /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UseMapOption"
      }, intl.format(Label.MapOption)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "UseMapOption",
        name: "UseMapOption",
        onChange: function onChange(e) {
          return _this9.updateUseMapOption(e);
        },
        value: this.state.UseMapOption,
        disabled: this.state.Use3dgsOption !== "1",
        tabIndex: 117
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(EnableOptions.Disabled)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(EnableOptions.Enabled))))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "UseFullbodyAvatarOption"
      }, intl.format(Label.FullbodyAvatarOption)), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "UseFullbodyAvatarOption",
        name: "UseFullbodyAvatarOption",
        onChange: function onChange(e) {
          return _this9.updateUseFullbodyAvatarOption(e);
        },
        value: this.state.UseFullbodyAvatarOption,
        tabIndex: 118
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(EnableOptions.Disabled)), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, intl.format(EnableOptions.Enabled)))), /*#__PURE__*/React.createElement("div", {
        className: "col-7"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "TrialStartDate"
      }, intl.format(Label.TrialStartDate)), /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement(ReactDatePicker, {
        key: (this.state.ContractAddFlag ? "add" : this.state.DisplayContractId != null ? this.state.DisplayContractId : "none") + "-TrialStartDate",
        customInput: /*#__PURE__*/React.createElement(CustomNotRequiredDateComponent, null),
        selected: this.state.TrialStartDate,
        onChange: this.updateTrialStartDate.bind(this),
        name: "TrialStartDate",
        id: "TrialStartDate",
        dateFormat: "YYYY/M/D",
        locale: "ja",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto row ".concat(this.state.ContractAddFlag || this.state.DisplayContractId != null ? "" : "d-none")
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-11 form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "time-col col-form-label",
        htmlFor: "PaidStartDate"
      }, intl.format(Label.PaidStartDate)), /*#__PURE__*/React.createElement("div", {
        className: "time-col"
      }, /*#__PURE__*/React.createElement(ReactDatePicker, {
        key: (this.state.ContractAddFlag ? "add" : this.state.DisplayContractId != null ? this.state.DisplayContractId : "none") + "-PaidStartDate",
        customInput: /*#__PURE__*/React.createElement(CustomNotRequiredDateComponent, null),
        selected: this.state.PaidStartDate,
        onChange: this.updatePaidStartDate.bind(this),
        name: "PaidStartDate",
        id: "PaidStartDate",
        dateFormat: "YYYY/M/D",
        locale: "ja",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select"
      })), /*#__PURE__*/React.createElement("div", {
        className: "time-span-col"
      }), /*#__PURE__*/React.createElement("label", {
        className: "time-col col-form-label",
        htmlFor: "ContractEndDate"
      }, intl.format(Label.ContractEndDate)), /*#__PURE__*/React.createElement("div", {
        className: "time-col"
      }, /*#__PURE__*/React.createElement(ReactDatePicker, {
        key: (this.state.ContractAddFlag ? "add" : this.state.DisplayContractId != null ? this.state.DisplayContractId : "none") + "-ContractEndDate",
        customInput: /*#__PURE__*/React.createElement(CustomNotRequiredDateComponent, null),
        selected: this.state.ContractEndDate,
        onChange: this.updateContractEndDate.bind(this),
        name: "ContractEndDate",
        id: "ContractEndDate",
        dateFormat: "YYYY/M/D",
        locale: "ja",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select"
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, this.props.mode == Mode.Add && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onEntry.bind(this),
        tabIndex: -1
      }, intl.format(Action.Entry)), this.props.mode == Mode.Modify && this.state.Deleted != ServiceStatuses.Suspended.toString() && [/*#__PURE__*/React.createElement("button", {
        key: "onModify",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onModify.bind(this),
        tabIndex: -1
      }, intl.format(Action.Update)), /*#__PURE__*/React.createElement("button", {
        key: "onChangeStatus",
        type: "button",
        className: "btn btn-default",
        onClick: this.onChangeStatus.bind(this),
        tabIndex: -1
      }, intl.format(Action.Suspend)), /*#__PURE__*/React.createElement("button", {
        key: "onDelete",
        type: "button",
        className: "btn btn-default",
        onClick: this.onDelete.bind(this),
        tabIndex: -1
      }, intl.format(Action.Delete))], this.props.mode == Mode.Modify && this.state.Deleted == ServiceStatuses.Suspended.toString() && [/*#__PURE__*/React.createElement("button", {
        key: "onModify",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onModify.bind(this),
        tabIndex: -1
      }, intl.format(Action.Update)), /*#__PURE__*/React.createElement("button", {
        key: "onChangeStatus",
        type: "button",
        className: "btn btn-default",
        onClick: this.onChangeStatus.bind(this),
        tabIndex: -1
      }, intl.format(Action.Resume)), /*#__PURE__*/React.createElement("button", {
        key: "onDelete",
        type: "button",
        className: "btn btn-default",
        onClick: this.onDelete.bind(this),
        tabIndex: -1
      }, intl.format(Action.Delete))]))));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };